<template>
    <div class="background" v-cloak>
        <div class="loader-container" v-if="loader">
            <Loader/>
        </div>
        <div class="row loan-container" v-if="!loader">
            <div :class="tableClass" class="inner-div table-padding">
                <div class="row">
                    <div class="col-md-6"><h2>Welcome {{name}}</h2></div>
                  <div class="col-md-6 notification">
                    <a-badge :count="totalUnseenNotifications" title="Custom hover text">
                        <i class="fas fa-bell" style='font-size:30px' data-toggle="modal" data-target="#notification"></i>
                    </a-badge>
                  </div>
                </div>
                <span style="color: #017438;"><i class="fas fa-user-friends" style="margin-right: 10px"></i>MSME LOAN LIST</span>
                <div class="row mt-3">
                    <div class="col-md-12">
                        <template>
                            <a-tabs style="width: 100%">
                                <a-tab-pane key="1" tab="Application">
                                    <div class="row mb-3 mt-3">
                                        <div class="col-md-2" style="padding-right: 9px;">
                                            <select @change="getFilteredData()" v-model="key" class="form-control">
                                                <option value="">All</option>
                                                <option v-for="status in statuses">
                                                    {{ status }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-2">
                                            <select @change="getLoansByFilteredType()" v-model="loanType" class="form-control">
                                                <option value="">Loan Type</option>
                                                <option v-for="loanType in loanTypes">
                                                    {{ loanType }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-md-2 offset-6">
                                            <button class="btn btn-primary float-right"  data-toggle="modal" data-target="#loanCreateModal"><i class="fas fa-plus"></i> <span>Create</span>
                                            </button>
                                        </div>
                                    </div>
                                    <v-client-table :data="tableData" :columns="columns" :options="options">
                    <span slot="action" slot-scope="{row}" style="margin-left: 10px">
                        <router-link class="view-button"
                                     :to="{name: 'loan-request-details', params: {id: row.id}}">view</router-link>
                    </span>
                                        <span slot="Date" slot-scope="{row}">
                        <div>{{ row.created_at}}</div>
                    </span>
                                        <template slot="Status" scope="props">
                                            <div class="status padding-right-15" :style="{
                                    borderTop: '18px solid ' + props.row.status_.color,
                                    borderLeft: '18px solid ' + props.row.status_.color,
                                    borderBottom: '18px solid '+ props.row.status_.color,
                        }"> {{props.row.status}}
                                            </div>
                                        </template>

                                        <template slot="child_row" scope="props">
                                            <div><b>Created by:</b> {{props.row.created_by_name}}</div>
                                            <div><b>Updated by:</b> {{props.row.updated_by_name}}</div>
                                            <div><b>Updated at:</b> {{props.row.updated}}</div>
                                        </template>
                                    </v-client-table>
                                </a-tab-pane>
                                <a-tab-pane key="2" tab="Report">
                                    <div id="accordion" class="accordion-div">
                                        <div class="card" style="margin-bottom: 8px">
                                            <div class="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                SMS Sending report
                                            </div>

                                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                <div class="card-body margin-40">
                                                    <div class="row">
                                                        <div class="col-md-3" style="text-align: right;align-self: center">Select date range</div>
                                                        <div class="col-md-3"><a-date-picker style="width: 100%"
                                                                                             :default-value="moment()"
                                                                                             :allowClear = false
                                                                                             :format="dateFormat"
                                                                                             @change="setStartDateForSmsReport"/>
                                                        </div>
                                                        <div class="col-md-1" style="width:3%; align-self: center; padding-right:0; padding-left:0; text-align: center">To</div>
                                                        <div class="col-md-3"><a-date-picker style="width: 100%"
                                                                                             :default-value="moment()"
                                                                                             :allowClear = false
                                                                                             :format="dateFormat"
                                                                                             @change="setEndDateForSmsReport"/>
                                                        </div>
                                                    </div>
                                                    <div class="row" style="margin-top: 10px">
                                                        <div class="col-md-3 offset-3"> <button class="button" @click="downloadReport('sms_sending')">Export</button></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card" style="margin-bottom: 8px">
                                            <div class="card-header collapsed" id="headingTwo" data-toggle="collapse"
                                                 data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Loan disbursement report
                                            </div>
                                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card-body margin-40">
                                                    <div class="row">
                                                        <div class="col-md-3" style="text-align: right;align-self: center">Select date range</div>
                                                        <div class="col-md-3"><a-date-picker style="width: 100%"
                                                                                             :default-value="moment()"
                                                                                             :allowClear = false
                                                                                             :format="dateFormat"
                                                                                             @change="setDisburseStartDate"/>
                                                        </div>
                                                        <div class="col-md-1" style="width:3%; align-self: center; padding-right:0; padding-left:0; text-align: center">To</div>
                                                        <div class="col-md-3"><a-date-picker style="width: 100%"
                                                                                             :default-value="moment()"
                                                                                             :allowClear = false
                                                                                             :format="dateFormat"
                                                                                             @change="setDisburseEndDate"/>
                                                        </div>
                                                    </div>
                                                    <div class="row" style="margin-top: 10px">
                                                        <div class="col-md-3 offset-3"> <button class="button" @click="downloadReport('disbursement')">Export</button></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header collapsed" id="headingThree" data-toggle="collapse"
                                                 data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                Loan Due report
                                            </div>
                                            <div id="collapseThree" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                <div class="card-body margin-40">
                                                    <div class="row">
                                                        <div class="col-md-3" style="text-align: right;align-self: center">Select date range</div>
                                                        <div class="col-md-3"><a-date-picker style="width: 100%"
                                                                                             :default-value="moment()"
                                                                                             :allowClear = false
                                                                                             :format="dateFormat"
                                                                                             @change="setDueStartDate"/>
                                                        </div>
                                                        <div class="col-md-1" style="width:3%; align-self: center; padding-right:0; padding-left:0; text-align: center">To</div>
                                                        <div class="col-md-3"><a-date-picker style="width: 100%"
                                                                                             :default-value="moment()"
                                                                                             :allowClear = false
                                                                                             :format="dateFormat"
                                                                                             @change="setDueEndDate" />
                                                        </div>
                                                    </div>
                                                    <div class="row" style="margin-top: 10px">
                                                        <div class="col-md-3 offset-3"> <button class="button" @click="downloadReport('due')">Export</button></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane key="3" tab="Dashboard">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label class="filter-label" for="dateFilter">Date Filter: </label>
                                            <a-range-picker
                                                    id="dateFilter"
                                                    show-time
                                                    :allowClear = false
                                                    :default-value="[moment().startOf('month'), moment()]"
                                                    :format="dateFormat"
                                                    @ok="onOk"
                                            >
                                            </a-range-picker>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 40px; margin-bottom: 60px">
                                        <div class="col-md-4">
                                            <div class="bordered">
                                                <div class="count">{{dashboardData.total_registration}}</div>
                                                <div class="count-header">Total ROBI Retailer Registered in sManager</div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="bordered">
                                                <div class="count">{{dashboardData.applied_loan}}</div>
                                                <div class="count-header">Applied for loan</div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="bordered">
                                                <div class="count">{{dashboardData.loan_approved}}</div>
                                                <div class="count-header">Loan Approved</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="bordered">
                                                <div class="count">{{dashboardData.loan_disburse}}</div>
                                                <div class="count-header">Loan Disburse</div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="bordered">
                                                <div class="count">{{dashboardData.loan_rejected}}</div>
                                                <div class="count-header">Reject</div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="bordered">
                                                <div class="count">{{dashboardData.loan_closed}}</div>
                                                <div class="count-header">closed</div>
                                            </div>
                                        </div>
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="notification" tabindex="-1" role="dialog"
             aria-labelledby="LoanCreate"
             aria-hidden="true">
            <div class="modal-dialog notification-modal" role="document">
                <div class="modal-content">
                    <div class="form" >
                        <div class="modal-header">
                            <h4 class="modal-title">Notifications</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="fas fa-times"></i></button>
                        </div>
                        <div class="modal-body">
                            <div class="notification-index" v-for="(notification ,index) in notifications" :key="index" @click="goTergetPage(notification.event_id, notification.id)">
                                <div class="notification-details">
                                    <div>{{ notification.title }}</div>
                                    <div class="notification-time">{{ notification.time }}</div>
                                </div>
                                <div v-if="!notification.is_seen" class="outer-circle">
                                    <div class="inner-circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="loanCreateModal" tabindex="-1" role="dialog"
             aria-labelledby="LoanCreate"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="!error">
                    <div class="form" v-if="!success">
                        <form v-on:submit.prevent="onSubmit">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ title }}</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="fas fa-times"></i></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="col-md-8 offset-2">
                                            <div class="inner-div" v-if="!submitting">
                                                <div class="form-group">
                                                    <label for="mobile">Mobile Number</label>
                                                    <input name="mobile" type="text" class="form-control" id="mobile"
                                                           placeholder="01*********" v-model="mobile_number">
                                                </div>
                                            </div>
                                            <div class="inner-loader" v-else>
                                                <img :src="loader_url" alt="loader" class="loader-image">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="padding-10">
                                    <button type="submit" class="btn btn-primary" :disabled="submitting">NEXT</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="success" v-else>
                        <div class="modal-header">

                            <h4 class="modal-title">
                                <button class="btn btn-icon" v-on:click="clearError"><i class="fa fa-arrow-left"></i>
                                </button>
                                {{ title }}
                            </h4>
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="fas fa-times"></i></button>
                        </div>
                        <div class="modal-body">
                            <div class="inner-div">
                                <div class="inner-div-icon svg">
                                    <svg xmlns="http://www.w3.org/2000/svg" id="success-checkmark-group" width="100%" height="100%" viewBox="0 0 128 128">
                                        <title> Success</title>
                                        <circle id="success-circle" cx="64" cy="64" r="59.4"></circle>
                                        <path id="success-checkmark" d="M24.75 62l27.5 27.5 51-51"></path>
                                    </svg>

                                </div>
                                <div class="inner-div-text">
                                    <p class="text-success">{{ message }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer center-align">
                            <a type="button" class="btn btn-primary"
                               :href="redirect_url+(created_loan?created_loan.id:'')">Okay </a>
                        </div>
                    </div>
                </div>
                <div class="modal-content" v-else>
                    <div class="modal-header">

                        <h4 class="modal-title">
                            <button class="btn btn-icon" v-on:click="clearError"><i class="fa fa-arrow-left"></i>
                            </button>
                            {{ title }}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="fas fa-times"></i></button>
                    </div>
                    <div class="model-body">
                        <div class="inner-div">
                            <div class="inner-div-icon">
                                <img :src="error_sign" alt="" class="img-responsive">
                            </div>
                            <div class="inner-div-text">
                                <p class="text-danger">{{message}}</p>
                            </div>
                            <div class="inner-div-link" v-if="error_code==404">
                                <a type="button" class="btn btn-link" target="_blank" :href="partner_create_link+mobile_number">
                                    {{ new_partner_text }}
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import moment from "moment";

    export default {
        name: "LoanRequests",
        components: {
            'Loader': () => import("./Loader")
        },
        data() {
            return {
                loader: false,
                key: "",
                loanType: "",
                dateFormat: 'YYYY-MM-DD',
                dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
                statuses: {},
                loanTypes: {micro_loan: "Micro Loan" , term_loan: "Term Loan"},
                columns: ['generated_id', 'Date', 'name', 'partner', 'type', 'phone', 'Status', 'action'],
                tableData: [],
                options: {
                    pagination: {chunk: 10, dropdown: false},
                    headings: {
                        generated_id: 'ID',
                        created_at: 'Date',
                        name: 'Applicant Name',
                        type: 'Loan Type',
                        phone: 'Applicant Mobile',
                        partner: 'Loan Trainer',
                    },
                    sortable: [
                        'generated_id', 'created_at', 'name', 'status'
                    ],
                    texts: {
                        filterPlaceholder: 'Search'
                    }
                },
                name: '',
                loan_bucket: [],
                tableClass: 'col-md-10 offset-md-1',
                redirect_url: '/loans/',
                submit_url: 'v2/loans/from-portal',
                loader_url: 'https://cdn-shebaxyz.s3.ap-south-1.amazonaws.com/partner_assets/assets/images/loan/loading.gif',
                partner_create_link: process.env.VUE_APP_PARTNER_REGISTRATION_LINK + '/register?mobile=',
                mobile_number: null,
                error: false,
                message: '',
                submitting: false,
                error_sign: 'https://cdn-shebaxyz.s3.ap-south-1.amazonaws.com/partner_assets/assets/images/loan/warning.svg',
                error_code: 0,
                new_partner_text: 'Register Partner',
                title: 'New Partner Loan',
                created_loan: null,
                success: false,
                success_icon_url: '../assets/success.gif',
                config: null,
                dashboardData: {
                    applied_loan: 0,
                    loan_approved: 0,
                    loan_closed: 0,
                    loan_disburse: 0,
                    loan_rejected: 0,
                    total_registration: 0
                },
                timer: '',
                reportDates: {
                    disbursementStartDate: this.moment().format('YYYY-MM-DD'),
                    disbursementEndDate: this.moment().format('YYYY-MM-DD'),
                    smsReportStartDate: this.moment().format('YYYY-MM-DD'),
                    smsReportEndDate: this.moment().format('YYYY-MM-DD'),
                    dueReportStartDate: this.moment().format('YYYY-MM-DD'),
                    dueReportEndDate: this.moment().format('YYYY-MM-DD'),
                },
                reportTypes: {disbursement: "disbursement", sms_sending: "sms_sending", due: "due" },
                notifications: [],
                totalUnseenNotifications: 0,
            }
        },
        computed: {
            ...mapGetters(['user']),
        },
        mounted: function () {
            let self = this;
            if (document.body.clientWidth < 1025) {
                self.tableClass = "col-md-12";
            }
            self.loader = true;
            self.name = self.user.name;
            this.config = {
                headers: {'Authorization': "bearer " + self.user.token}
            };

            self.getLoanRequests(this.config);
            self.getStatuses(this.config);
            self.getNotifications(this.config);
        },
        created() {
            window.addEventListener("resize", this.myEventHandler);
            this.fetchDashboardData();
            this.timer = setInterval(this.fetchDashboardData, 200000)
        },
        destroyed() {
            window.removeEventListener("resize", this.myEventHandler);
        },
        methods: {
            fetchDashboardData () {
                const self = this;
                const config = {
                    headers: {'Authorization': "bearer " + self.user.token}
                };
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/dashboard`, config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.dashboardData = response.data.data
                        }
                    });
            },
            setStartDateForSmsReport(date, value) {
                this.reportDates.smsReportStartDate = value;
            },
            setEndDateForSmsReport(date, value) {
                this.reportDates.smsReportEndDate = value;
            },
            setDisburseStartDate(date, value) {
                this.reportDates.disbursementStartDate = value;
            },
            setDisburseEndDate(date, value) {
                this.reportDates.disbursementEndDate = value;
            },
            setDueStartDate(date, value) {
                this.reportDates.dueReportStartDate = value;
            },
            setDueEndDate(date, value) {
                this.reportDates.dueReportEndDate = value;
            },
            downloadReport(type) {
                const self = this;
                if(type === self.reportTypes.disbursement){
                    window.open(process.env.VUE_APP_API_URL + `/v2/loans/loan-disbursement-report?start_date=${self.reportDates.disbursementStartDate}&end_date=${self.reportDates.disbursementEndDate}&token=${self.user.token}`);
                }
                if(type === self.reportTypes.due){
                    window.open(process.env.VUE_APP_API_URL + `/v2/loans/loan-due-report?start_date=${self.reportDates.dueReportStartDate}&end_date=${self.reportDates.dueReportEndDate}&token=${self.user.token}`);
                }
                if(type === self.reportTypes.sms_sending){
                    window.open(process.env.VUE_APP_API_URL + `/v2/loans/ipdc-sms-sending-report?start_date=${self.reportDates.smsReportStartDate}&end_date=${self.reportDates.smsReportEndDate}&token=${self.user.token}`);
                }
            },
            getFilteredData() {
                const self = this;
                if (self.key !== "") {
                    self.tableData = self.loan_bucket.filter(function (el) {
                        return el.status === self.key;
                    });
                } else {
                    self.tableData = self.loan_bucket;
                }
            },
            getLoansByFilteredType() {
                const self = this;
                if (self.loanType !== "") {
                    self.tableData = self.loan_bucket.filter(function (loan) {
                        return loan.type === self.loanType;
                    });
                } else {
                    self.tableData = self.loan_bucket;
                }
            },
            myEventHandler(e) {
                if (document.body.clientWidth < 1025) {
                    this.tableClass = "col-md-12";
                }
            },
            getStatuses(config) {
                const self = this;
                axios.get(process.env.VUE_APP_API_URL + '/v2/loans/statuses', config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.statuses = response.data.data;
                        } else {
                            self.$store.commit('logout');
                            self.$router.push({name: 'login'});
                        }
                    }).catch(function (error) {
                    console.log(error)
                })
            },
            getNotifications(config) {
                const self = this;
                axios.get(process.env.VUE_APP_API_URL + '/v1/bank-user/notifications', config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.notifications = response.data.data.notifications;
                            self.totalUnseenNotifications = response.data.data.unseen_notifications_count;
                        } else {
                            console.log(response.data)
                        }
                    }).catch(function (error) {
                    console.log(error)
                })
            },
            getLoanRequests(config) {
                var self = this;
                axios.get(process.env.VUE_APP_API_URL + '/v2/loans', config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.tableData = response.data.data;
                            self.loan_bucket = response.data.data;
                            self.loader = false;
                        } else {
                            self.$store.commit('logout');
                            self.$router.push({name: 'login'});
                        }
                    }).catch(function (error) {
                    self.$store.commit('logout');
                    self.$router.push({name: 'login'});
                })
            },
            onSubmit() {
                const self = this;
                self.submitting = true;
                axios.post(process.env.VUE_APP_API_URL + '/v2/loans/from-portal', {mobile: self.mobile_number}, self.config).then(res => {
                    if (res.data.code === 200) {
                        self.onSuccess(res.data)
                    } else {
                        self.onError(res.data)
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
            onError(err) {
                this.submitting = false;
                this.error = true;
                this.message = err.message ? err.message : err.responseText;
                this.error_code = err.code ? err.code : 500;
            },
            onSuccess(res) {
                this.success = true;
                this.error = false;
                this.submitting = false;
                this.message = res.message ? res.message : "New Loan Created";
                this.created_loan = res.data;
            },
            clearError() {
                this.error = false;
                this.success = false;
                this.message = '';
            },
            onOk(value) {
                const self = this;
                self.start_date = moment(value[0]._d).format('YYYY-MM-DD');
                self.end_date = moment(value[1]._d).format('YYYY-MM-DD');
                const config = {
                    headers: {'Authorization': "bearer " + self.user.token}
                };
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/dashboard?from_date=${self.start_date}&to_date=${self.end_date}`, config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.dashboardData = response.data.data
                        }
                    });
            },
            goTergetPage(loan_id, notification_id) {
                const url = '/loans/' + loan_id;
                //  const url = '/loans/205';
                axios.get(process.env.VUE_APP_API_URL + `/v1/bank-user/notification-seen/${notification_id}`, this.config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            window.location = url;
                        }
                    });
            },
            moment,
        }
    }
</script>

<style>
    .accordion-div .card-header:after {
        font-family: "Font Awesome 5 Free";
        content: "\f068";
        display: inline-block;
        padding-right: 3px;
        vertical-align: middle;
        font-weight: 600;
        float: right;
    }
    .ant-tabs-bar {
        margin: 0 0 40px 0;
    }
    .accordion-div .card-header.collapsed:after {
        /* symbol for "collapsed" panels */
        content: "\f067";
    }

    .button {
        display: inline-block;
        margin-bottom: 0;
        font-weight: 400;
        text-align: center;
        vertical-align: middle;
        touch-action: manipulation;
        cursor: pointer;
        border: 1px solid transparent;
        white-space: nowrap;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        color: #fff;
        background-color: #337ab7;
    }
    .button:focus {
        color: #fff;
        background-color: #286090;
        border-color: #122b40;
    }
    .ant-tabs ant-tabs-top ant-tabs-line {
        width: 100% !important;
    }
    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: 10px auto;
        text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
        content: "+";
        font-size: 18px;
        font-weight: 500;
    }

    .VueTables__child-row-toggler--open::before {
        content: "-";
        font-size: 18px;
        font-weight: 500;
    }

    .VueTables__child-row--closed {
        display: none;
    }

    .VueTables__date-filter {
        border: 1px solid #ccc;
        padding: 6px;
        border-radius: 4px;
        cursor: pointer;
    }

    .VuePagination__pagination {
        position: absolute !important;
        right: -12px !important;
    }

    .VueTables__search-field label {
        display: none;
    }

    .VueTables__search-field input {
        margin-top: 25px !important;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #F0F7FD;
    }
</style>

<style scoped>
    .filter-label {
        margin-right: 10px;
        font-size: 16px;
    }
    .bordered {
        border: 1px solid #39B54A;
        border-radius: 6px;
        text-align: center;
        color: black;
        padding: 40px 20px;
    }
    .count {
        font-size: 49px;
    }
    .count-header {
        font-size: 12px;
    }
    .notification-modal {
        position: absolute !important;
        max-width: 500px !important;
        margin: 0 auto !important;
        right: 0 !important;
        top: 0 !important;
        width: 100% !important;
    }
    .bordered-top {
        text-align: center;
        cursor: pointer;
    }
    .active {
        border-top: 3px solid green;
    }
    .notification {
        align-self: center;
        text-align: right;
    }
    .notification svg {
        font-size: 24px;
        cursor: pointer;
    }
    .notification-index {
        display: flex;
        padding: 10px 5px;
        border-bottom: 1px solid darkgray;
        cursor: pointer;
    }
    .outer-circle {
        background-color:#ababab;
        color:white;
        width: 20px;
        height: 20px;
        border-radius:50%;
        text-align:center;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
    .inner-circle {
        background-color: #6a85a0;
        color: black;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin: 0 auto;
    }
    .unseen {
        height: 14px;
        width: 14px;
        background-color: #bbb;
        border-radius: 50%;
        display: inline-block;
    }
    .notification-time {
        font-size: 13px;
        color: darkgray;
        font-style: italic;
    }
    .notification-details {
        flex-grow: 1;
    }
    .deposit-sign-red {
        height: 16px;
        width: 16px;
        background-color: red;
        border-radius: 50%;
        display: inline-block;
        margin: 0px 6px 3px 0;
        vertical-align: middle;
    }
    .deposit-request{
        border: 1px solid #CED4DA;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 6px 12px;
        display: inline-block;
    }
    .status {
        border-right: 15px solid transparent;
        border-radius: 5px;
        height: 0;
        line-height: 0;
        color: white;
    }

    .table-padding {
        padding: 20px 100px 40px;
    }

    .loader-container {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .background {
        background-color: #eef1f5;
    }

    .inner-div {
        background-color: white;
        margin-top: 20px;
    }

    .view-button {
        color: #010101;
        font-size: 16px;
        padding: 6px 12px;
        border: 1px solid rgba(255, 255, 255, 0);
    }

    .view-button:hover {
        text-decoration: none;
        border: 1px solid #0091ff;
        color: white;
        background-color: #0091ff;
        padding: 6px 12px;
        border-radius: 4px;
    }

    .loan-container {
        padding: 50px 0 100px 0
    }
    .inner-loader {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        width: 100%;
        padding: 40px;
        position: relative;
    }

    .inner-loader img {
        display: flex;
        width: 100%;
        max-width: 100px;
        max-height: 100px;
    }

    .modal-content .inner-div {
        display: flex;
        width: 100%;
        padding: 50px 0;
        align-items: center;
        justify-content: center;
        flex-flow: column wrap;
    }

    .inner-div-icon, .inner-div-text {
        margin-bottom: 10px;
        text-wrap: normal;
        max-height: 100px;
    }

    #success-checkmark-group {
        width: 100%;
        height: 100%;
        max-height: 100px;
    }

    #success-checkmark-group #success-circle, #success-checkmark {
        fill: none;
        stroke: #8ac34b;
        stroke-linecap: round;
        stroke-miterlimit: 10;
        stroke-width: 4px;
        stroke-dasharray: 400;
    }

    .text-success {
        color: #8ac34b;
    }

    #success-checkmark {
        animation: checkmark-stroke .6s forwards;
        animation-timing-function: ease-in;
        animation-delay: .2s;
        stroke-linejoin: round;
        opacity: 0;
    }

    @keyframes checkmark-stroke {
        0% {
            stroke-dashoffset: 400;
            opacity: 1;
        }
        100% {
            stroke-dashoffset: 0;
            opacity: 1;
        }
    }

    #success-checkmark-group #success-circle {
        animation: circle-stroke .8s forwards;
    }

    @keyframes circle-stroke {
        from {
            stroke-dashoffset: -400;
        }
        to {
            stroke-dashoffset: 0;
        }
    }
    @media only screen and (max-width: 1024px) {
        .status {
            padding-right: 15px;
        }

        .table-padding {
            padding: 10px;
        }

        .loan-container {
            padding: 5px 0 50px 0
        }
    }

    @media (min-width: 992px) {
        .table-padding {
            padding: 20px 40px 40px;
        }
    }
</style>
